import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import { useAuth } from "@/contexts/AuthContext";
import { useIsMobile } from "@/hooks/useIsMobile";
import { Link } from "@/i18n/navigation";
import { getUserMenuData } from "@/utils/userMenuData";
import clsx from "clsx";

const UserMenuContent = () => {
  const t = useTranslationDetector();
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);

  const { isLogin, getInitials, getUserName, session, loading, logout } =
    useAuth();

  const menuData = getUserMenuData(t);

  if (!isLogin) return null;

  return (
    <div className="flex flex-col gap-4">
      <div
        className={clsx(
          "flex flex-col rounded-xl md:flex md:rounded-none",
          isMobile && !isOpen ? "hidden" : "flex",
        )}
      >
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-3 py-2">
            <div className="bg-primary flex h-10 w-10 items-center justify-center rounded-full font-medium text-white">
              {getInitials()}
            </div>
            <div className="flex flex-col text-left">
              <div className="text-primary text-lg font-medium">
                {getUserName()}
              </div>
              <span className="text-sm font-medium truncate max-w-[150px]">
                {session?.Email || ""}
              </span>
            </div>
          </div>

          <div className="border-border-weaker border-b"></div>

          {menuData
            .filter((item) => !item.hideUserFlyOut)
            .map((item, index) => (
              <React.Fragment key={item.id}>
                <Link
                  href={item.href}
                  className={clsx(
                    "flex items-center rounded-lg py-3 transition-colors",
                    item.icon && "gap-3",
                  )}
                >
                  {item.icon && (
                    <span className="text-primary text-[22px]">
                      {item.icon}
                    </span>
                  )}
                  <span className="font-medium">{item.text}</span>
                </Link>
                <div className="border-border-weaker border-b"></div>
              </React.Fragment>
            ))}
        </div>
        <button
          className="flex cursor-pointer items-center gap-3 rounded-lg py-3 transition-colors"
          onClick={logout}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["log-out"]}
            className="text-primary text-[22px]"
          />
          <span className="font-medium">{t("usermenu.logout")}</span>
        </button>
      </div>
    </div>
  );
};

export default UserMenuContent;
